/* Built In Imports */
/* External Imports */

import { Box } from "@chakra-ui/react";
import MediaEmbedV2 from "@components/Embeds/MediaEmbedV2";
import SectionTitle from "@components/Headings/SectionTitle";
import TopKolam from "@components/Headings/TopKolam";

/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const SneakPeak = ({ sectionContent, region, language }) => {
    // console.log("The sneak peak is", sectionContent)
    return (
        <Box paddingTop={"0px"} >
            {sectionContent.map((section, index) => {
                if (section?._modelApiKey === 'section_title') {
                    return (
                        <Box key={index}

                        >
                            <SectionTitle
                                width={{ sm: "282px", base: "282px", md: "400px" }}
                                titleObj={section}
                                titleDecoration="none"
                                color="black"
                                fontSize={{ base: "30px", sm: "30px", md: "38px" }}
                                lineHeight={{ base: "37px", sm: "37px", md: "38px" }}
                                marginTop={{ sm: "-20px", base: "-20px", md: "40px" }}
                                mx={{ base: 'auto', md: 'auto' }}

                            />
                        </Box>
                    );
                }

                if (section?._modelApiKey === 'top_kolam') {
                    return (
                        <Box key={index} marginTop={"-20px"}>
                            <TopKolam
                                sectionContent={section}
                            />
                        </Box>
                    )
                }

                if (section?._modelApiKey === 'media_embed_v2') {
                    return (
                        <Box
                            pos={'relative'}
                            maxWidth={'678px'}
                            margin={{ base: '0 auto', sm: "", md: "-25px auto" }}
                            w={{ base: '90%' }}
                        >
                            <MediaEmbedV2 sectionContent={section}
                                width={{ base: '100%', md: '678px' }} bgcolor={'#BB3E03'} txtcolor={'#ffffff'} />
                        </Box>
                    )
                }

            })}
        </Box>

    );
};

export default SneakPeak;
